/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Separator/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Separator({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Apps/CustomResources/Content/CustomResource/Separator"
  
}) {
let customResourceItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'custom_resource_item',
path: 'isLast',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Separator.Vertical"
  data-view-path={viewPath}
 style={{'--bc-2-ZEj6d5': dtColorsNeutral300,'--ml-4-ZEj6d5': customResourceItemIsLastValueData ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mr-3-ZEj6d5': customResourceItemIsLastValueData ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--w-1-ZEj6d5': customResourceItemIsLastValueData ? "0px" : "1px"}}
 className={`views-block ${styles.Vertical}`}
/>
{children}
</React.Fragment>)
}